export class SubFLIFormHelper {
    static generateSubFliName(caption: string, min: number, max: number, language: string): string {
        // will give a number from (min) to (max) (inclusive).
        const randomString = min + Math.floor(Math.random() * max);
        const generatedName = caption + '-' + randomString;
        return generatedName;
    }
}
